import React from 'react';
import { Modal, Paper, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => {
    return {
        modal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        root: {
            width: '800px',
            padding: '56px',
            height: '400px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',

            borderRadius: '10px',
            border: '2px solid #009ADE',
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px 0',
        },
        button: {
            width: '150px',
        },
        footer: {
            display: 'flex',
            gap: '100px',
            justifyContent: 'center',
        },
    };
});

interface CassetteWarningModalProps {
    isOpen: boolean;
    onClose: Function;
}

export const CassetteWarningModal = ({
    isOpen,
    onClose,
}: CassetteWarningModalProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Modal className={classes.modal} open={isOpen}>
            <Paper className={classes.root}>
                <div className={classes.header}>
                    <Typography variant='h3'>
                        {t('Insert Cash Cassette')}
                    </Typography>
                </div>
                <div className={classes.body}>
                    <Typography
                        align='center'
                        variant='h4'
                        style={{ fontWeight: 'normal' }}
                    >
                        {t(
                            'Please, insert the cash cassette back into the Cash Acceptor'
                        )}
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button
                        className={classes.button}
                        variant='primary'
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <Typography variant='button'>OK</Typography>
                    </Button>
                </div>
            </Paper>
        </Modal>
    );
};
